import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import patient from '../stores/patient';

const Wrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	align-items: stretch;
	width: 20rem;
	position: relative;
	height: 20rem;
	border-radius: 10rem;
	overflow: hidden;
	transform: rotate(45deg);
	border: 1px solid #ccc;
	margin: 1.25rem 0;
	&:first-child {
		margin-top: 0;
	}
	&:last-child {
		margin-bottom: 0;
	}
`;

const Square = styled.div`
	display: flex;
	width: 10rem;
	height: 10rem;
	flex: 1 0 50%;
	align-items: center;
	justify-content: center;
	color: #555;
	font-weight: bold;
	font-size: 2rem;
	& span {
		transform: rotate(-45deg);
		color: black;
	}
	background-color: ${props => (
		(props.color === 'RED' && '#F0948A') ||
		(props.color === 'YELLOW' && '#FCF995') ||
		(props.color === 'GREEN' && '#C5F696') ||
		'white'
	)};
	${props => props.center && `
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 6rem;
		height: 6rem;
		border-radius: 3rem;
	`}
	${props => props.top && `
		border-right: 2px solid white;
		border-bottom: 2px solid white;
	`}
	${props => props.right && `
		border-left: 2px solid white;
		border-bottom: 2px solid white;
	`}
	${props => props.left && `
		border-top: 2px solid white;
		border-right: 2px solid white;
	`}
	${props => props.bottom && `
		border-top: 2px solid white;
		border-left: 2px solid white;
	`}
`;

@observer
class OCT extends Component {
	render() {
		const { eye } = this.props;
		let vals;
	
		if (eye === 'left') {
			vals = {
				S: patient.fields.octLeftS,
				N: patient.fields.octLeftN,
				I: patient.fields.octLeftI,
				T: patient.fields.octLeftT,
			};
		} else {
			vals = {
				S: patient.fields.octRightS,
				N: patient.fields.octRightN,
				I: patient.fields.octRightI,
				T: patient.fields.octRightT,
			};
		}

		return (
			<Wrap>
				<Square color={vals.S} top><span>{vals.S[0]}</span></Square>
				{eye === 'left' && 
					<Fragment>
						<Square color={vals.N} right><span>{vals.N[0]}</span></Square>
						<Square color={vals.T} left><span>{vals.T[0]}</span></Square>
					</Fragment>
				}
				{eye !== 'left' && 
					<Fragment>
						<Square color={vals.T} right><span>{vals.T[0]}</span></Square>
						<Square color={vals.N} left><span>{vals.N[0]}</span></Square>
					</Fragment>
				}
				<Square color={vals.I} bottom><span>{vals.I[0]}</span></Square>
				<Square center />
			</Wrap>
		);
	}
}

export default OCT;



// WEBPACK FOOTER //
// ./src/components/OCT.js